module.exports = __webpack_public_path__ + "static/media/transfericon.0d18f3bf.svg";